<template>
	<div class="home">
		<div class="nav-card">
			<router-link to="/work" class="nav-item right hidden sm:block">
				<div class="arrow rotate-right"></div>
				<span class="text-white">Work</span>
			</router-link>

			<a class="nav-item down hidden sm:block" href="jm-resume-2019.pdf" target="_blank">
				<div class="arrow rotate-down"></div>
				<span class="text-white">Download Résumé</span>
			</a>

			<router-link to="/about" class="nav-item left hidden sm:block">
				<div class="arrow rotate-left"></div>
				<span class="text-white">About</span>
			</router-link>

			<div class="be-you bg-white p-8 rounded-lg">
				<div class="text-orange uppercase font-bold mb-4">UX/UI Designer</div>
				<div class="text-3xl font-semibold text-light-gray font-archivo">
					Hello, my name is <span class="text-green">John Milly.</span>
				</div>
			</div>

			<ul class="mobile-nav sm:hidden">
				<li>
					<router-link to="/work" class="flex justify-between items-center">
						<span class="text-white">Work</span>
						<div class="arrow white rotate-right"></div>
					</router-link>
				</li>
				<li>
					<router-link to="/about" class="flex justify-between items-center">
						<span class="text-white">About</span>
						<div class="arrow white rotate-left"></div>
					</router-link>
				</li>
				<li>
					<a class="flex justify-between items-center" href="jm-resume-2019.pdf" target="_blank">
						<span class="text-white">Résumé</span>
						<div class="arrow white rotate-down"></div>
					</a>
				</li>
			</ul>
		</div>

		<div class="in-depth" v-if="this.indepth">
			<div class="alert">
				In-depth case studies coming soon. <span class="hidden sm:inline ml-2"> Until then, enjoy the visuals.</span>
				<!-- <i class="times times-white cursor-pointer" @click="fadeOut"></i> -->
			</div>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'

import { mapState, mapMutations } from 'vuex';

export default {
	name: 'home',
	computed: mapState([
		'projects',
		'indepth'
	]),
	components: {

	},
	methods: {
		...mapMutations([
			'APP_CLASS',
			'REMOVE_INDEPTH'
		]),
		fadeOut: function() {
			let fadeTarget = document.querySelector('.in-depth');
			let fadeEffect = setInterval(() => {
				if (!fadeTarget.style.opacity) {
					fadeTarget.style.opacity = 1;
				}
				if (fadeTarget.style.opacity > 0) {
					fadeTarget.style.opacity -= 0.1;
				} else {
					clearInterval(fadeEffect);
					this.REMOVE_INDEPTH();
				}
			}, 50);
		}
	},
	created: function() {
		this.APP_CLASS('page-home hungry');
	}
}
</script>
